import { ApolloProvider } from '@apollo/client';

import { SignablePackageComponentProps } from '../features/signable-package/data';
import SignablePackage from '../features/signable-package/SignablePackage';
import { client } from '../graphql/client';
import { IdempotencyProviderWithFeatureRegistry } from '../providers/IdempotencyProviderWithFeatureRegistry';

const SignablePackageApp: React.FC<React.PropsWithChildren<SignablePackageComponentProps>> = props => (
  <ApolloProvider client={client}>
    <IdempotencyProviderWithFeatureRegistry featureName="signablePackage">
      <SignablePackage {...props} />
    </IdempotencyProviderWithFeatureRegistry>
  </ApolloProvider>
);

export default SignablePackageApp;
